<template>
  <omint-page>
    <Header name="Documentos de Apoio" titleLabel="Documentos de Apoio"
backRoute="/" />
    <omint-page-content :message="error">
      <div v-if="myFiles && myFiles.length > 0">
        <div v-for="(file, idx) in myFiles" :key="'sec-' + idx">
          <omt-divider v-if="idx !== 0" />
          <omt-h5>
            <b>{{ file.name }}</b>
          </omt-h5>
          <div>
            <a
              v-for="(doc, i) in file.itemCollection"
              :key="idx + 'files-' + i"
              :href="doc.Url"
              :download="doc.Name"
              target="_blank"
            >
              {{ doc.Name }}
              <br />
            </a>
          </div>
        </div>
      </div>
    </omint-page-content>
    <Footer />
  </omint-page>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "MyFiles",
  components: { Header, Footer },
  data() {
    return {
      error: null
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters("myFiles", ["myFiles"]),
    isMobile() {
      return isMobile();
    }
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    ...mapActions("myFiles", ["listFiles"]),
    ...mapMutations("myFiles", ["SET_DOC"]),
    async fetchData() {
      this.error = null;
      try {
        await this.$root.$emit("show-loading");
        await this.listFiles();
      } finally {
        this.error = !this.myFiles || this.myFiles.length === 0 ? "Nenhum documento encontrado" : null;
        await this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>
